import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

const unAnsweredInquiryStatus = async (param) => {
  const { data } = await axios.get(`${baseUrl}/csCenter/read/unAnswered`, {
    params: param,
  });
  return data;
};

const unansweredProductQuestion = async () => {
  const { data } = await axios.get(
    `${baseUrl}/userProductQuestionHistory/read/noAnswer`,
  );
  return data;
};

const readInquiryListForAdmin = async () => {
  const { data } = await axios.get(`${baseUrl}/inquiry/list`);
  return data;
};

const readInquiryList = async () => {
  const { data } = await axios.get(`${baseUrl}/admin/inquiry/list`);
  return data;
};

const removeInquiry = async (id) => {
  const { data } = await axios.delete(`${baseUrl}/admin/inquiry/delete${id}`);
  return data;
};
const deleteInquiryAnswer = async (inquiryAnswer_id) => {
  const { data } = await axios.delete(
    `${baseUrl}/admin/inquiry/answer/delete/${inquiryAnswer_id}`,
  );
  return data;
};
const totalCntList = async (searchText, searchType) => {
  const { data } = await axios.get(
    `${baseUrl}/admin/inquiry/totalCntList?searchText=${searchText}&searchType=${searchType}`,
  );
  return data;
};

const searchInquiry = async (offset, pageSize, searchType, searchText) => {
  const { data } = await axios.get(
    `${baseUrl}/admin/inquiry/list?offset=${offset}&pageSize=${pageSize}&searchType=${searchType}&searchText=${searchText}`,
  );
  return data;
};

const editInquiry = async (editInquiry) => {
  const { data } = await axios.put(
    `${baseUrl}/admin/inquiry/edit`,
    editInquiry,
  );
  return data;
};

// const editInquiryAnswer = async (inquiryAnswer_param)=> {
//     const {data} = await axios.put(`${baseUrl}/admin/inquiry/answer/edit`,inquiryAnswer_param )
//     return data
// }

const createInquiry = async (createInquiry) => {
  const { data } = await axios.post(
    `${baseUrl}/admin/inquiry/add`,
    createInquiry,
  );
  return data;
};

const createInquiryAnswer = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/admin/inquiry/answer/add`,
    param,
  );
  return data;
};

const sortInquiry = async (offset, pageSize, orderCategory, orderType) => {
  const { data } = await axios.get(
    `${baseUrl}/admin/inquiry/list?offset=${offset}&pageSize=${pageSize}&orderCategory=${orderCategory}&orderType=${orderType}`,
  );
  return data;
};

const readInquiry = async (id) => {
  const { data } = await axios.get(`${baseUrl}/admin/inquiry/${id}`);
  return data;
};

const readUserInquiryList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/admin/user/inquiry/list`, {
    params: param,
  });
  return data;
};

const getInquiryAnswer = async (user_id) => {
  const { data } = await axios.get(
    `${baseUrl}/inquiry/answer/list?user_id=${user_id}`,
  );
  return data;
};

const getRecommendedResultList = async (param) => {
  const { data } = await axios.get(
    `${baseUrl}/recommendSystem/get/recommend/result`,
    {
      params: param,
    },
  );
  return data;
};

const getRecommendedNutrients = async (param) => {
  const { data } = await axios.get(
    `${baseUrl}/recommendSystem/get/recommended/nutrients/by/id`,
    {
      params: param,
    },
  );
  return data;
};

const interlockNutrientsRead = async (param) => {
  const { data } = await axios.get(
    `${baseUrl}/interlock/nutrients/read/${param.user_id}`,
  );
  return data;
};

const inquiryAnswerRecommend = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/inquiry/answer/recommend`,
    param,
  );
  return data;
};

const inquiryAnswerComplete = async (user_id, answer_created_by) => {
  const { data } = await axios.get(
    `${baseUrl}/inquiry/answer/complete?user_id=${user_id}&answer_created_by=${answer_created_by}`,
  );
  return data;
};

const readProductInquiryOne = async (question_id) => {
  const { data } = await axios.get(
    `${baseUrl}/userProductQuestionHistory/readOne?question_id=${question_id}`,
  );
  return data;
};

const readProductInquiryList = async (
  offset,
  pageSize,
  startDate,
  endDate,
  answerStatus,
  searchType,
  searchValue,
  userId,
) => {
  const { data } = await axios.get(
    `${baseUrl}/userProductQuestionHistory/read/admin/list?offset=${offset}&pageSize=${pageSize}&startDate=${startDate}&endDate=${endDate}&answerStatus=${answerStatus}&searchType=${searchType}&searchValue=${searchValue}&userId=${userId}`,
  );
  return data;
};

const createProductInquiryAnswer = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userProductQuestionHistory/createAnswer`,
    param,
  );
  return data;
};

const editProductInquiryAnswer = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userProductQuestionHistory/editAnswer`,
    param,
  );
  return data;
};

const deleteProductInquiryAnswer = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userProductQuestionHistory/deleteAnswer`,
    param,
  );
  return data;
};

const searchRecommendReason = async (param) => {
  const { data } = await axios.get(`${baseUrl}/admin/recommendReason/search`, {
    params: param,
  });
  return data;
};

const readRecommendInquiryList = async (
  offset,
  pageSize,
  startDate,
  endDate,
  answerStatus,
  orderType,
  orderBy,
) => {
  const { data } = await axios.get(
    `${baseUrl}/recommendInquiry/admin/list?offset=${offset}&pageSize=${pageSize}&startDate=${startDate}&endDate=${endDate}&answerStatus=${answerStatus}&orderType=${orderType}&orderBy=${orderBy}`,
  );
  return data;
};

const getRecommendInquiryOne = async (inquiry_id) => {
  const { data } = await axios.get(
    `${baseUrl}/recommendInquiry/admin/one?inquiry_id=${inquiry_id}`,
  );
  return data;
};

const createRecommendInquiryAnswer = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/recommendInquiry/answer/create`,
    param,
  );
  return data;
};

// NutrientsGPT
const getModelListForGPT = async () => {
  const { data } = await axios.get(`${baseUrl}/nutrientsGPT/modelList`);
  return data;
};

const getGPTChatListByUserId = async (param) => {
  const { data } = await axios.get(`${baseUrl}/nutrientsGPT/listByUser`, {
    params: param,
  });
  return data;
};

const chatGPT = async (param) => {
  const { data } = await axios.post(`${baseUrl}/nutrientsGPT/chat`, param);
  return data;
};

const inquiryApi = {
  unAnsweredInquiryStatus,
  unansweredProductQuestion,
  readInquiryListForAdmin,
  readInquiryList,
  removeInquiry,
  deleteInquiryAnswer,
  totalCntList,
  searchInquiry,
  editInquiry,
  // editInquiryAnswer,
  createInquiry,
  createInquiryAnswer,
  sortInquiry,
  readInquiry,
  getInquiryAnswer,
  getRecommendedResultList,
  getRecommendedNutrients,
  readUserInquiryList,
  interlockNutrientsRead,
  inquiryAnswerRecommend,
  inquiryAnswerComplete,
  readProductInquiryOne,
  readProductInquiryList,
  createProductInquiryAnswer,
  editProductInquiryAnswer,
  deleteProductInquiryAnswer,
  searchRecommendReason,
  readRecommendInquiryList,
  getRecommendInquiryOne,
  createRecommendInquiryAnswer,
  getModelListForGPT,
  getGPTChatListByUserId,
  chatGPT,
};

export default inquiryApi;
